import { CommentCommunication } from '@seen/core/models/communications/CommentCommunication'
import type { ExtendedImmunization } from '@seen/core/models/immunizations/ExtendedImmunization'
import type { JSX } from 'react'
import { ActivityComment } from '#src/components/activity/ActivityComment.tsx'
import { useSearch } from '#src/hooks/useSearch.ts'

export function ImmunizationActivity({
  immunization,
}: {
  immunization: ExtendedImmunization
}): JSX.Element {
  const { data: comments = [] } = useSearch(
    CommentCommunication,
    CommentCommunication.searchQuery([immunization.reference])
  )

  return (
    <>
      {comments.map((comment) => (
        <ActivityComment key={comment.reference.reference} comment={comment} />
      ))}
    </>
  )
}
